import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import CheckIcon from "@mui/icons-material/Check.js";
import { Bubbles, Bubble, BubbleDetails } from "./TimeFrames.styles.js";
import "@mui/material";
import "@mui/system";
const initialTimeFrames = [
  { [encodeURI("timeOfDay[0].start")]: "08:00", [encodeURI("timeOfDay[0].end")]: "12:00", isActive: true },
  { [encodeURI("timeOfDay[1].start")]: "12:00", [encodeURI("timeOfDay[1].end")]: "17:00", isActive: true },
  { [encodeURI("timeOfDay[2].start")]: "17:00", [encodeURI("timeOfDay[2].end")]: "20:00", isActive: true }
];
const TimeFrames = ({ onSelectSlot, labels: { noon, beforeNoon, evening } }) => {
  const initialFilterSlots = useMemo(() => initialTimeFrames, []);
  const titles = useMemo(() => [beforeNoon, noon, evening], []);
  const [filterSlots, setFilterSlots] = useState(initialFilterSlots);
  const handleBubbleClick = (index) => () => {
    const updatedSlots = filterSlots.map((slot, currentIndex) => {
      if (currentIndex !== index)
        return slot;
      return {
        ...slot,
        isActive: !slot.isActive
      };
    });
    const filteredSlots = updatedSlots.filter(({ isActive }) => isActive);
    if (!filteredSlots.length && filterSlots[index].isActive)
      return;
    setFilterSlots(updatedSlots);
    onSelectSlot(filteredSlots);
  };
  return /* @__PURE__ */ jsx(Bubbles, { children: filterSlots.map((slot, index) => {
    const [start, end] = Object.values(slot);
    const variant = slot.isActive ? "filled" : "bordered";
    return /* @__PURE__ */ jsx(Bubble, { onClick: handleBubbleClick(index), startIcon: /* @__PURE__ */ jsx(CheckIcon, {}), variant, children: /* @__PURE__ */ jsxs(BubbleDetails, { children: [
      /* @__PURE__ */ jsx("span", { children: titles[index] }),
      /* @__PURE__ */ jsx("span", { children: `${start}-${end}` })
    ] }) }, titles[index]);
  }) });
};
export {
  TimeFrames as default,
  initialTimeFrames
};
